import {Component, Injector, Input, ViewChild} from '@angular/core';
import {TableComponent} from "../../../ui/table/table.component";
import {ShopService} from "../../../../services/shop/shop.service";
import {NgxSmartModalService} from "ngx-smart-modal";
import {Router} from "@angular/router";
import {BaseComponent} from "../../../base/base.component";
import {ProductBarcode} from "../../../../models/shop/productBarcode";
import {ProductMovement} from "../../../../models/shop/productMovement";
import Swal from "sweetalert2";

@Component({
  selector: 'app-shop-movement',
  templateUrl: './barcode-movement.component.html',
  styleUrls: ['./barcode-movement.component.scss']
})
export class BarcodeMovementComponent extends BaseComponent {
    @Input() barcodeId?: string | undefined | null;
    @ViewChild('barcodeMovementList') barcodeMovementList: TableComponent | undefined;

    constructor(public shopService: ShopService,
                public serviceInjector: Injector,
                public modal: NgxSmartModalService,
                private router: Router) {
        super(serviceInjector);}

    async ngAfterViewInit() {
        this.barcodeMovementList?.loadData(`/productMovements`, {barcodeId: this.barcodeId}, ((item: any) => new ProductMovement(item)))
    }

    navigateToEditPage(barcodeId: any, barcodeMovementId: string, pageType?: string){
        const params: {} = {
            barcodeId: barcodeId,
            barcodeMovementId: barcodeMovementId,
            pageType: pageType
        }
        this.router.navigate(['companies/shop/barcodeMovement/edit'], {queryParams: params})
    }

    async deleteBarcodeMovement(movementId: string) {
        this.showSpinner()
        await this.shopService.deleteBarcodeMovement(movementId).then(
            (response: any) => {
                if (response.success) {
                    Swal.fire({
                        icon: 'success',
                        title: "Movimento di magazzino eliminato con successo!"
                    });
                    this.barcodeMovementList?.reloadPage();
                }
            }
        ).catch((error: any) => {
            Swal.fire({
                icon: 'error',
                title: "Errore, non è stato possibile eliminare il movimento di magazzino!"
            });
            console.error("deleteBarcodeMovement error: " + error.stack)
        }
        )
        this.hideSpinner()
    }

}
